<div class="overlay" [class.right]="isRight" [class.special]="special" [class.smallUp]="smallUp">
  <div class="small box"></div>
  <img class="small" [src]="smallerImageUrl" alt="Obrazek">
  <div class="big box"></div>
  <img class="big" [src]="biggerImageUrl" alt="Obrazek">
</div>
<app-contact-dots *ngIf="isRight || special" [class.right]="isRight" [class.special]="special"></app-contact-dots>
